module.exports = __webpack_public_path__ + "static/media/img_61.4cce3bfc.png";